import React from "react"
import "twin.macro"
import { Link } from "react-scroll"

const nav = [
  {
    img: "https://img.icons8.com/ios/24/000000/contacts.png",
    link: "about",
  },
  {
    img: "https://img.icons8.com/ios/24/000000/pinterest--v1.png",
    link: "portfolio",
  },
  {
    img: "https://img.icons8.com/ios/24/000000/toolbox.png",
    link: "experience",
  },
  {
    img: "https://img.icons8.com/ios/24/000000/align-cell-content-left.png",
    link: "reff",
  },
  {
    img: "https://img.icons8.com/ios/24/000000/border-color.png",
    link: "blog",
  },
  {
    img: "https://img.icons8.com/ios/24/000000/reading-confirmation.png",
    link: "contact",
  },
]
const Navber = () => {
  return (
    <div tw="flex justify-center md:(flex-col col-span-1) sticky top-0">
      {nav.map((item, index) => (
        <div tw="p-3">
          <Link
            activeClass="active"
            tw="cursor-pointer overflow-x-visible"
            smooth={"easeInOutQuint"}
            to={item.link}
          >
            <img src={item.img} />
          </Link>
        </div>
      ))}
    </div>
  )
}
export default Navber
